import React, {
    useState,
    useEffect,
} from 'react';

import {
    FontAwesomeIcon,
} from "@fortawesome/react-fontawesome";

import {
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import * as s from './pagination.module.css'

interface PaginationProps {
    count: number,
    page: number,
    onChange: ( page: number ) => void,
}

const Pagination: React.FC<PaginationProps> = ({
    count,
    page: currentPage,
    onChange,
}) => {
    const [ pages, setPages ] = useState<Array<number>>([]);

    useEffect(() => {
        let limit = 1;
        const pages = [];

        while( limit <= count ) {
            pages.push( limit );

            limit ++;
        }

        setPages( pages );
    }, [ count ]);

    return (
        <div className={ s.pagination }>
            <button
                className={ s.arrow }
                onClick={() => onChange( currentPage - 1 )}
            >
                <FontAwesomeIcon
                    className={s.iconArrow}
                    icon={faChevronLeft}
                />
            </button>

            {
                pages.map( page =>
                    <button
                        key={ page }
                        className={`${ s.page } ${ currentPage === page && s.selected }`}
                        onClick={() => onChange( page )}
                    >
                        { page }
                    </button>
                )
            }

            <button
                className={ s.arrow }
                onClick={() => onChange( currentPage + 1 )}
            >
                <FontAwesomeIcon
                    className={s.iconArrow}
                    icon={faChevronRight}
                />
            </button>
        </div>
    );
}

export {Pagination}